// extracted by mini-css-extract-plugin
export var noScroll = "styles-module--noScroll--99ba6";